import { Box, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import palette from "../../../theme/palette";

type Props = {
  text: string;
  icon?: ReactNode;
};

const IconWithText = ({ text, icon }: Props) => {
  return (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, "& svg": { maxWidth: 18, maxHeight: 18 }, }}>
      {icon}
      <Typography
        variant="body1" sx={{ color: palette.secondary.main, fontWeight: 500 }}>
        {text}
      </Typography>
    </Box>
  );
};

export default IconWithText;
